import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import { getColorStyle, getFontFamilyStyle } from './utils.styles';

// Header Names - Navigation (Header)
// Welcome Message - Header Photo (Header)
// Wedding Names AND Ampersand - Body (Header)
// Title - Story (Header) - H2
// Seals or Initials - (Header)
// Page Titles (Header) - H1
export const getHeaderFontOverride = (
  fontColor?: string | null,
  fontFamily?: string | null
): SerializedStyles | '' => {
  if (!(fontColor || fontFamily)) return '';
  const colorStyle = getColorStyle(fontColor);
  const familyStyle = getFontFamilyStyle(fontFamily);
  const fontStyle = `
    ${colorStyle} ${familyStyle}
  `;
  return css`
    #public-wrapper {
      .sticky-nav #public-page-header h1 a {
        ${fontStyle}
      }

      .hero-wrapper .home-page-hero.no-image .homepage-header-text h1 {
        ${fontStyle}
      }

      .hero-wrapper .home-page-hero.has-image .homepage-header-text h1 {
        ${familyStyle}
      }

      #wedding-party-page,
      #faq-page,
      #events-page,
      #photos-page,
      #poi-page,
      #travel-page,
      #registry-page,
      #rsvp-page-v2 {
        .cms-page-header h1 {
          ${fontStyle}
        }
      }

      .big-initial,
      .big-initial.day,
      .big-initial.month {
        ${fontStyle}
      }

      .name-1,
      .name-2,
      .amp,
      .and,
      .plus {
        ${fontStyle}
      }

      h1,
      h2,
      h3,
      h5 {
        :not(&.wedding-date, &.wedding-location, &.hashtag, &.location, &.date, &.month, &.day, &.year) {
          ${fontStyle}
        }
      }

      h1.for-small-laptops {
        ${fontStyle}
      }

      // Registry side nav header
      :not(#registry-zola h6) {
        ${fontStyle}
      }
    }
  `;
};
